class QeviqFaqAccordionGroup extends HTMLElement {
  connectedCallback() {
    this.details = Array.from(this.querySelectorAll('details'));

    this.details.forEach((detail) => {
      detail.addEventListener('toggle', () => {
        if (!detail.open) return;

        this.details.forEach((otherDetail) => {
          if (otherDetail !== detail) {
            otherDetail.open = false;
          }
        });
      });
    });
  }
}

if (!customElements.get('qeviq-faq-accordion-group')) {
  customElements.define('qeviq-faq-accordion-group', QeviqFaqAccordionGroup);
}
